
export const  API_BASE_URL = process.env.REACT_APP_BASE_URL ;  

export const APP_BASE_NAME = process.env.BUSINESS_NAME ;  